import React from "react";
import "../styles/Stats.css";
import {
  FaUsers,
  FaProjectDiagram,
  FaHeadset,
  FaGasPump,
} from "react-icons/fa";

const Stats = () => {
  const stats = [
    {
      icon: <FaUsers />,
      number: "100+",
      title: "Happy Clients",
    },
    {
      icon: <FaProjectDiagram />,
      number: "250+",
      title: "Projects Completed",
    },
    {
      icon: <FaGasPump />,
      number: "500+",
      title: "Fuel Nozzles Connected",
    },
    {
      icon: <FaHeadset />,
      number: "24/7",
      title: "Technical Support",
    },
  ];

  return (
    <section className="stats">
      <div className="stats-container">
        {stats.map((item, index) => (
          <div className="stat-card" key={index}>
            <div className="stat-icon">{item.icon}</div>

            <h2>{item.number}</h2>

            <p>{item.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
